import React from "react";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import ErrorText from "../error-success/ErrorText";
import SuccessWrap from "../error-success/SuccessWrap";

class GeneratePasswordConfirmationDialog extends React.PureComponent {
	render() {
		const { generateSuccess, generateErrors } = this.props;

		let buttons = [];

		// Action was a success
		if (generateSuccess) {
			buttons = [
				{
					type: Button,
					text: "Ok",
					action: () => {
						this.props.handleClose();
					}
				}
			];
		}
		// Action can still be confirmed
		else {
			buttons = [
				{
					type: Button,
					text: "Cancel",
					action: () => this.props.handleClose(),
					disabled: this.props.generateInProgress
				},
				{
					type: Button,
					text: "Yes",
					action: () => this.props.handleGenerate(this.props.id),
					disabled: this.props.generateInProgress
				}
			];
		}

		return this.props.show ? (
			<Modal title={"Confirm Password Update"} buttons={buttons}>
				{/* Loading */}
				{this.props.generateInProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<div>
						{generateSuccess ? (
							<SuccessWrap animate={1}>{generateSuccess}</SuccessWrap>
						) : (
							<div>
								<div>
									Are you sure you want to generate a new password for
									{this.props.itemTitle ? <span className="item_name_block">{this.props.itemTitle}</span> : "this user"}?
								</div>
								{generateErrors && <ErrorText errors={generateErrors} animate={1} />}
							</div>
						)}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default GeneratePasswordConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/GeneratePasswordConfirmationDialog.js